import { Trans } from "@web-monorepo/i18n/macro";
import { DDSButton } from "@web-monorepo/dds";
import * as React from "react";
import styles from "./SlideNavigation.module.css";

const SlideNavigation: React.FC<{
  onBack: () => void;
  onNext: () => void;
}> = ({ onBack, onNext }) => (
  <div className={styles.wrapper}>
    <DDSButton data-name="slide_navigation:slide_navigation.back" variant="tertiary" onClick={onBack}>
      <Trans>Back</Trans>
    </DDSButton>
    <DDSButton data-name="slide_navigation:slide_navigation.next" width="fill" onClick={onNext}>
      <Trans>Next</Trans>
    </DDSButton>
  </div>
);

export default SlideNavigation;
